import {
  MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBRadio
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { getMisc, updateRole } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddLocation from "../../../views/popups/roles/AddLocation";
import DeleteLocation from "../../../views/popups/roles/DeleteLocation";
import SaveChanges from "../../topviews/saveCancel";


export function GeneralSettings({ defaultRolesInfo, setReRender, isDisabled, setErrorMessage, setHasPrevilege, setEdited }) {
  const { t } = useTranslation();
  const [roleUpdated, setRoleUpdated] = useState(false);
  const [message, setMessage] = useState("");
  const [internalError, setInternalError] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isSupervisor, setIsSupervisor] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [allLocations, setAllLocations] = useState(true); // It is a flag to know wheater it is a all locations or specifice location.
  const [addedLocations, setAddedLocations] = useState([]); // Newly added locations using add locations button.
  const [existingLocations, setExistingLocations] = useState([]); // Adding the already added locations.
  const [allAvailableLocations, setAllAvailableLocations] = useState([]); // All Existing DB Details.
  const [closingPopup, setClosingPopup] = useState(false); // flag is used to know the child popup is closed.
  const [totalAddedLocations, setTotalAddedLocations] = useState([]); // Modifed rows data,added delete condition.
  const [enableAddLocation, setEnableAddLocation] = useState(false); // It is use to enable the Add location  popup.
  const enableDisableAddLocation = () => setEnableAddLocation(!enableAddLocation);
  const [deleteLocation, setDeleteLocation] = useState(false);
  const dtogglePopup = () => setDeleteLocation(!deleteLocation);
  const [deleteAcceptFlag, setDeleteAcceptFlag] = useState(false);
  const [removeLocationId, setRemoveLocationId] = useState(0);
  const [locationFlag, setLocationFlag] = useState(false);
  const [actualDefaultAllLoc, setActualDefaultAllLoc] = useState(true);
  const addLocRoleRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);

  function handleClick() {
    addLocRoleRef.current.click();
  }

  //React Hook form 
  const { register, reset, watch, getValues, formState: { dirtyFields, isDirty, errors }, setValue, handleSubmit, setError, unregister } = useForm();

  // MDTable information.
  const advancedData = {
    columns: [
      { label: "Name", field: "location_name", sort: true },
      { label: "Address", field: "address" },
      { label: "Remove", field: "delete", sort: false },
    ],
    rows: totalAddedLocations
  };

  // verifying the dirty fields.
  const isdirtyFields = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    setEdited(isdirtyFields)
  }, [isdirtyFields])

  //API request to update the role.
  const onSaveChanges = async (data) => {
    try {
      if (isDirty) {
        setReRender(false);
        let modifiedData = fetchModifiedData(data);
        // adding additional data to Request
        modifiedData.reqid = 27;
        modifiedData.siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
        modifiedData.roles_id = data.id;
        modifiedData.role = data.role;
        modifiedData.logined_user = JSON.parse(sessionStorage.getItem("admin_session")).logined_user;
        console.log(`Coverted Data For Roles Info::${JSON.stringify(modifiedData)}`);
        //sending the request to API service to update.
        let response = await updateRole(modifiedData);
        let resdata = await response.json();
        if (response.status === 200) {
          setMessage(resdata.message); // success pop up message.
          setRoleUpdated(true); // enabling sucesss popup 
          reset();
          register("all_locations");
          setReRender(true); // Re- Rednering the child componenet in order to stay in the same page after saving with latest updated data.
        } else if (response.status === 400) {
          if (resdata.message?.errors) {
            console.log("errors are ::: ", resdata.message?.errors)
            resdata.message.errors.forEach((err) => {
              if (err.param_name === "logined_user") {
                setHasPrevilege(true);
                setErrorMessage(err.message)
                reset();
              }
              setError(err.param_name, {
                type: "server",
                message: err.message,
              });
            });
          }

        } else if (response.status === 500) {
          setInternalError(true);
        }
      }
    } catch (e) {
      console.log(`Unable to send update Role to API:${e}`);
      setInternalError(true);
    }


  }

  // Fetched the complete modified data to send to update role api.
  function fetchModifiedData(data) {
    let modifiedData = {};
    for (const field of Object.keys(dirtyFields)) {
      // Check if the field is dirty and exists in the data object
      if (dirtyFields[field] && data.hasOwnProperty(field)) {
        // If the field is an object, extract modified subfields
        if (typeof data[field] === "object") {
          modifiedData[field] = {};

          for (const subfield of Object.keys(dirtyFields[field])) {
            if (data[field].hasOwnProperty(subfield)) {
              modifiedData[field][subfield] = data[field][subfield];
            }
          }
        } else {
          // If it's not an object, add the entire field
          modifiedData[field] = data[field];
        }
      }
    }

    //modifying the true or false to 1 or 0
    if (modifiedData.hasOwnProperty('permissions')) {
      for (const key in modifiedData.permissions) {
        if (modifiedData.permissions.hasOwnProperty(key)) {
          if (key != 9) {
            modifiedData.permissions[key] = modifiedData.permissions[key] ? 1 : 0;
          } else {
            let val = +modifiedData.permissions[key];
            if (val == 1) {
              modifiedData.permissions[9] = 1;
              modifiedData.permissions[10] = 0;
            } else {
              modifiedData.permissions[9] = 0;
              modifiedData.permissions[10] = 1;
            }
          }
        }
      }
    }
    if (modifiedData.hasOwnProperty('location')) {
      modifiedData.location = +modifiedData.location
    }
    return modifiedData;
  }


  // Define custom validation rules for permissions checkboxes,then only it works.
  const checkboxValidation = {
    validate: (value) => {
      if (!(Object.values(value).some((isChecked) => isChecked))) {
        return "At least one permission must be selected.";
      }
      return undefined; // Validation passed
    },
  };

  // Register the permissions field with custom validation rules
  register("permissions", checkboxValidation);

  //Cancel case operation.
  const onCloseChanges = () => {
    reset(defaultRolesInfo);
    setActualDefaultAllLoc(actualDefaultAllLoc);
    setLocationFlag(actualDefaultAllLoc);
    //setValue("all_locations", actualDefaultAllLoc, {shouldDirty:false});
  }

  // Loading the default data.
  useEffect(() => {
    if (Object.keys(defaultRolesInfo ?? {}).length > 0) {
      console.log(`OErsmison back ennd:: ${JSON.stringify(defaultRolesInfo.permissions)}`);
      reset(defaultRolesInfo);
      setIsSuperAdmin(defaultRolesInfo.name === 'Super Admin' && defaultRolesInfo.siteid === 0);
      setIsSupervisor(defaultRolesInfo.name === 'Supervisor' && defaultRolesInfo.siteid === 0);
      setIsAdmin(defaultRolesInfo.name === 'Admin' && defaultRolesInfo.siteid === 0);

      console.log(`After resetting of the data::: ${JSON.stringify(watch())}`);
      setLocationFlag(defaultRolesInfo.all_locations);
      //Setting the existing locations.
      setAllLocations(defaultRolesInfo.all_locations);
      setActualDefaultAllLoc(defaultRolesInfo.all_locations);
      setExistingLocations(defaultRolesInfo.added_locs);
      frameAndSetTotalAddedLocations(defaultRolesInfo.added_locs);
    }
  }, [defaultRolesInfo]); // Re-render when reRenderKey changes


  //Fetching all available locations in the account.
  // async function getAllLocations() {
  //   const response = await getLocations(JSON.parse(sessionStorage.getItem("admin_session")).siteid);
  //   if (!response.json) {
  //     const message = `An error has occured: ${response.statusText}`;
  //     return;
  //   }
  //   const data = await response.json();
  //   if (!data) {
  //     window.alert(`info with id  not found`);
  //     Navigate("/");
  //   }
  //   setAllAvailableLocations(data.locations);
  // }
  // useEffect(() => {
  //   getAllLocations(); // fetching the locations at the time of add Admin Role.
  // }, []);



  async function getAllLocations() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      const params = {
        misc: ["all_locations_roles"],
      };

      const serverResponse = await getMisc(siteid, params);
      if (!serverResponse.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const responseData = await serverResponse.json();
        console.log("Response Data:", JSON.stringify(responseData));
        setAllAvailableLocations(responseData?.misc?.all_locations ?? []);
      }
    } catch (error) {
      console.error("[fetchAllLocations] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  useEffect(() => {
    getAllLocations();

  }, []);


  // Frames the MDBTable data for locations.
  function frameAndSetTotalAddedLocations(totalLocations) {
    let framedRowsInfo = totalLocations.map((infoObj) => ({
      ...infoObj,
      delete: (
        <a
          style={{ zIndex: 99996 }}
          href="#"
          onClick={(e) => removeLocation(e, infoObj.location_id)}
          target="_new"
        >
          <MDBIcon fas icon="times" color="primary" />
        </a>
      )
    }));
    setTotalAddedLocations(framedRowsInfo ?? [])
  }
  //After adding the Add location
  useEffect(() => { //Add location popup related add button .
    if (closingPopup == true) {
      setClosingPopup(false);
      //Combing the New Data to existing Data 
      let finalExistingLocations = [...existingLocations, ...addedLocations];
      frameAndSetTotalAddedLocations(finalExistingLocations);
    }
  }, [closingPopup]);

  // sending individual request for Added Locations and removed locations.
  async function sendAddRemoveLocationsReq(addedLocs, removedLocs) {
    try {
      let modifiedData = {
        reqid: 27,
        siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
        roles_id: defaultRolesInfo.id,
        role: defaultRolesInfo.role,
        ...(addedLocs && { added_locs: addedLocs, all_locations: false }),
        ...(removedLocs && { removed_locs: removedLocs }),
      };
      console.log(`modifiedData::${JSON.stringify(modifiedData)}`);
      let response = await updateRole(modifiedData);
      if (response.status === 200) {
        setActualDefaultAllLoc(false);
        if (addedLocs) {
          setMessage(`Locations added successfully to the role.`); // success pop up message.
        } else {
          setMessage(`Locations removed successfully from the role.`); // success pop up message.  
          //Removing the entries from totalAddedLocations 
          setTotalAddedLocations((prevLocations) => {
            let filterData = prevLocations.filter(obj => !removedLocs.includes(obj.location_id));
            return filterData;
          });
          setExistingLocations((prevLocations) => {
            let filterData = prevLocations.filter(obj => !removedLocs.includes(obj.location_id));
            return filterData;
          });

        }
        setRoleUpdated(true); // enabling sucesss popup 
        return; // returning the control from here itself
      } else if (response.status === 400) {
        let errRes = await response.json();
        setError('all_locations', {
          type: "server",
          message: errRes.message?.errors[0]?.message,
        });

      }
    } catch (e) {
      setInternalError(true);
    }
  }

  // sending  the add location to api.
  useEffect(() => {
    if (addedLocations?.length > 0) {
      let addedLocs = addedLocations.map(obj => obj.location_id);
      sendAddRemoveLocationsReq(addedLocs);
      setAddedLocations([]);
    }
  }, [addedLocations]);

  //Removing fucntion  
  function removeLocation(event, removeLocId) {
    event.stopPropagation();
    event.preventDefault();
    dtogglePopup();
    setRemoveLocationId(removeLocId);
  }

  //Removing the lcoation 
  useEffect(() => {
    if (deleteAcceptFlag && removeLocationId !== 0) {
      setDeleteAcceptFlag(false);
      setRemoveLocationId(0);
      sendAddRemoveLocationsReq(undefined, [removeLocationId]);
    }
  }, [deleteAcceptFlag]);

  return (

    <>
      <div className="scrollspy-example2">

        <div className="d-flex justify-content-between align-items-center">
          <div className="general-settings">
            {t("general")}
          </div>
          {isSuperAdmin && <p>{t("generaltext")}</p>}
        </div>
        <form className={isDisabled ? 'disabled-form cursor-notAllowed' : ''}
          title={isDisabled && "Do not have previlege to edit role"}
        >
          <div>
            <div className="add-numbermain">
              <div className="tel-numbers">{t("name")}</div>
              <div className="form w-30 pt-2">
                <MDBInput
                  type="text"
                  maxLength={50}
                  className="w-100"
                  {...register('name', {
                    required: {
                      value: true,
                      message: 'Name cannot be empty'
                    },
                  })}
                  disabled={isSuperAdmin || isSupervisor || isAdmin}
                />
                {errors.name && (
                  <p className="text-danger">{errors.name.message}</p>
                )}
              </div>
            </div>
            <div className="add-numbermain">
              <div className="tel-numbers mt-3">
                {t("Description")}
              </div>
              <div className="form pt-2 w-30">
                <textarea
                  id="textAreaExample"
                  className="w-100"
                  rows={2}
                  {...register("description")}
                  disabled={isSuperAdmin || isSupervisor || isAdmin}
                />
              </div>
            </div>
            {isSupervisor === false &&
              <>
                <div className="add-numbermain">
                  <p className=" d-block">{t("ManageSeats")}</p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        value={watch("permissions.1")}
                        checked={watch("permissions.1")}
                        onChange={(e) => {
                          setValue("permissions.1", e.target.checked, { shouldDirty: true })
                          setValue("permissions.2", e.target.checked, { shouldDirty: true })
                        }}
                        // {...register('permissions.1')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("AddDelEditUsers")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        // {...register('permissions.2')}
                        value={watch("permissions.2")}
                        checked={watch("permissions.2")}
                        onChange={(e) => {
                          setValue("permissions.2", e.target.checked, { shouldDirty: true })
                          setValue("permissions.1", e.target.checked, { shouldDirty: true })
                        }}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("Adddeleditaccfeat")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.3')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("ManageAdmins")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.4')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("Accessuserdatareports")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.5')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("Accessusercallrec")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.6')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("AdddeleditPermissionRoles")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.7')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("Accessbillingsect")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.8')}
                        disabled={isSuperAdmin}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </>
            }
            {isSupervisor &&
              <>
                <div className="add-numbermain">
                  <div className="tel-numbers">{t("access_to_calls")}</div>
                  <div className="d-flex w-30">
                    <div className="phoneselect w-100">
                      <select
                        name="permissions.9"
                        className="form-control form-select selectname w-100"
                        {...register('permissions.9')}
                        onChange={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setValue("permissions.9", parseInt(e.target.value), { shouldDirty: true });
                        }}
                      >
                        <option value={1} > Group Calls Only(Default)</option>
                        <option value={0}> All Calls</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="add-numbermain">
                  <p className=" d-block">
                    {t("manage_hg_acd_queue_settings")}
                  </p>
                  <div className="phoneselect">
                    <label className="switch">
                      <input className="form-control"
                        type="checkbox"
                        {...register('permissions.11')}
                      />
                      <span className="slider round"></span>
                    </label>
                  </div>
                </div>
              </>
            }
            {errors.permissions && (
              <p className="text-danger">{errors.permissions.message}</p>
            )}
            {isSupervisor === false &&
              <>
                <div className="add-numbermain mb-5">
                  <p className=" d-block">{t("location")}</p>
                  <div className="d-flex justify-content-evenly">
                    <div>
                      <MDBRadio
                        id='inlineRadio1'
                        value={true}
                        disabled={isDisabled}
                        label='All Locations'
                        inline
                        checked={locationFlag === true}
                        onChange={() => {
                          if (actualDefaultAllLoc === false && locationFlag === false) {
                            setValue("all_locations", true, { shouldDirty: true });
                            setLocationFlag(true);
                          } else {
                            setLocationFlag(true);
                          }
                        }
                        }
                      />
                    </div>
                    <div>
                      <MDBRadio
                        id='inlineRadio2'
                        value={false}
                        label='Select Location'
                        inline
                        checked={locationFlag == false}
                        onChange={() => {
                          unregister("all_locations");
                          setLocationFlag(false);
                        }
                        }
                        disabled={isSuperAdmin || isDisabled}
                      />
                    </div>
                  </div>
                </div>
              </>
            }
            {locationFlag == false && (
              <>
                <div className=" mt-2 d-flex justify-content-end w-100">
                  <MDBBtn
                    className="green-button "
                    data-mdb-toggle="modal"
                    data-mdb-target="#exampleModal"
                    onClick={(e) => { e.stopPropagation(); e.preventDefault(); enableDisableAddLocation(); }}
                  >
                    <MDBIcon fas icon="plus" size="sm" /> {t("addlocation")}
                  </MDBBtn>
                </div>
                {(errors.all_locations) && (
                  <p className="text-danger">{errors.all_locations.message}</p>
                )}
                <div className="permissionRoleDataTable pb-5">
                  <MDBDatatable
                    maxHeight="63vh"
                    sortField="Name"
                    sortOrder="asc"
                    fixedHeader
                    entries={1000000}
                    searchInputProps={[]}
                    data={advancedData}
                    pagination={false}
                    className="mt-2 actioncolumn"
                  />
                </div>
              </>
            )}
          </div>
          {isdirtyFields && (
            <SaveChanges
              onClose={onCloseChanges}
              onSave={(e) => {
                e.preventDefault();
                handleSubmit(onSaveChanges)();
              }}
            />
          )}
        </form>
        {roleUpdated && (
          <MDBAlert
            open
            className="alert-center"
            color="success"
            autohide
            position="bottom-right"
            delay={5000}
            onClose={() => setRoleUpdated(false)}
          >
            <i className="fas fa-check-circle me-3"></i>
            <span className="alert-msg">{message}</span>
          </MDBAlert>
        )}
        {internalError && (<MDBAlert
          show
          color="danger"
          autohide
          position="bottom-right"
          delay={5000}
          onClose={() => setInternalError(false)}
        >Internal Server Error</MDBAlert>)}


        {enableAddLocation && (
          <PopupLoaderNew
            // size="lg"
            // className="modal-lg"
            title="Add Location"
            content={<AddLocation
              onClose={enableDisableAddLocation}
              closingPopup={setClosingPopup}
              existingLocations={existingLocations}
              setAddedLocations={setAddedLocations}
              allLocations={allAvailableLocations}
              ref={addLocRoleRef}
              setIsloading={setisLoading}
            />}
            onShow={setEnableAddLocation}
            onClose={enableDisableAddLocation}
            onSave={handleClick}
            isloading={isLoading}
            flag={1}
          />
        )}

        {deleteLocation && (
          <PopupLoaderNew
            title={"Remove Role Location"}
            content={
              <DeleteLocation
                onClose={dtogglePopup}
                setDeleteLocFlag={setDeleteAcceptFlag}
                ref={addLocRoleRef}
                setIsloading={setisLoading}
              />
            }
            onShow={setDeleteLocation}
            onClose={dtogglePopup}
            onSave={handleClick}
            isloading={isLoading}
            flag={4}
          />
        )}
      </div>
    </>

  );
}